import { render, staticRenderFns } from "./SkeletonLoading.vue?vue&type=template&id=5a5c7130&scoped=true&"
import script from "./SkeletonLoading.vue?vue&type=script&lang=js&"
export * from "./SkeletonLoading.vue?vue&type=script&lang=js&"
import style0 from "./SkeletonLoading.vue?vue&type=style&index=0&id=5a5c7130&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a5c7130",
  null
  
)

export default component.exports